<div *ngFor="let type of columnsByTypes" class="fake_column"
     [ngStyle]="{'width': type === 'composite' ? '561px' : '280px'}"></div>

